export const appName = 'own-calendar';
